export default __webpack_public_path__ + "static/media/img (2).62ddd99d.jpg";